import React, { createContext, useContext, useEffect, useState } from 'react';

interface NavigationContextValue {
  isRootView: boolean;
  popToRoot: () => void;
}

const NavigationContext = createContext<NavigationContextValue>({
  isRootView: false,
  popToRoot: () => {}
});

export const useNavigationContext = () => useContext(NavigationContext);

interface NavigationProviderProps {
  children: React.ReactNode;
  navRef?: React.RefObject<HTMLIonNavElement>;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children, navRef }) => {
  const [isRootView, setIsRootView] = useState(false);

  useEffect(() => {
    if (navRef?.current) {
      navRef.current.addEventListener('ionNavDidChange', (event: any) => {
        event.target.getActive().then((activeView: any) => {
          if (activeView) {
            setIsRootView(activeView.component.name === 'root'); 
          }
        });
      });
    }
  }, [navRef]);

  const popToRoot = () => {
    navRef?.current?.popToRoot();
  };

  return (
    <NavigationContext.Provider value={{ isRootView, popToRoot }}>
      {children}
    </NavigationContext.Provider>
  );
};